import React from "react";
import { STAGES, stageIndex } from "../../../utils/knowledgeStatus";

const count = (value) =>
  typeof value === "number" ? value.toLocaleString() : null;

/**
 * What the crawl is doing, from GET /assistants/:id/knowledge-status.
 *
 * Every number and sentence is the API's: the message above the bar, the page
 * counts either side of it, and which of the five stages is running. Nothing
 * here advances on a timer, so the bar cannot claim progress that is not
 * happening.
 *
 * @param {object} state  from readKnowledgeStatus()
 */
export default function KnowledgeProgress({ state }) {
  if (!state) return null;

  const current = stageIndex(state.stage);
  // Pages are only counted while they are being read; the later stages have
  // no number behind them, so the bar is left out rather than parked at 100%.
  const hasBar = state.percent !== null;

  return (
    <div className="kn-progress">
      <span className="kn-progress__eyebrow">Learning your website</span>

      <h3 className="kn-progress__title">
        {state.message || "Reading your website"}
      </h3>

      {state.website && (
        <p className="kn-progress__site">{state.website}</p>
      )}

      {/* At the very start the counts are null - the stage is "discovering"
          and nothing has been found yet - so the message stands alone. */}
      {hasBar && (
        <>
          <div className="kn-progress__bar">
            <span style={{ width: `${state.percent}%` }} />
          </div>

          <div className="kn-progress__counts">
            <span>{state.percent}%</span>
            {state.pagesFound !== null && (
              <span>{count(state.pagesFound)} pages found on your site</span>
            )}
          </div>
        </>
      )}

      <ol className="kn-progress__stages">
        {STAGES.map((stage, index) => {
          const done = current > index;
          const active = current === index;

          return (
            <li
              key={stage.key}
              className={`${done ? "is-done" : ""}${active ? " is-active" : ""}`.trim()}
            >
              <span className="kn-progress__stage-line" />
              <span className="kn-progress__stage-label">
                {done && "✓ "}
                {stage.label}
              </span>
            </li>
          );
        })}
      </ol>
    </div>
  );
}
